import { BaseGenerator } from '../core/BaseGenerator.js';

/**
 * Polish PESEL generator following Single Responsibility Principle
 */
export class PeselGenerator extends BaseGenerator {
  generate(options = {}) {
    const { birthDate = null, gender = null } = options;

    let yymmdd;
    if (birthDate) {
      const date = new Date(birthDate);
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      const day = this.padZero(date.getDate(), 2);

      // Handle century encoding
      if (year >= 1800 && year <= 1899) {
        month += 80;
      } else if (year >= 2000 && year <= 2099) {
        month += 20;
      } else if (year >= 2100 && year <= 2199) {
        month += 40;
      } else if (year >= 2200 && year <= 2299) {
        month += 60;
      }

      yymmdd = year.toString().slice(-2) + this.padZero(month, 2) + day;
    } else {
      const year = this.padZero(this.randomInt(0, 99), 2);
      const month = this.padZero(this.randomInt(1, 12), 2);
      const day = this.padZero(this.randomInt(1, 28), 2);
      yymmdd = year + month + day;
    }

    // Generate serial number (3 digits)
    let serial = this.randomDigits(3);
    
    // Adjust last digit for gender if specified
    if (gender === 'male') {
      serial = serial.slice(0, 2) + (parseInt(serial[2]) % 2 === 0 ? parseInt(serial[2]) + 1 : serial[2]);
    } else if (gender === 'female') {
      serial = serial.slice(0, 2) + (parseInt(serial[2]) % 2 === 1 ? parseInt(serial[2]) - 1 : serial[2]);
    }

    // Calculate check digit
    const partial = yymmdd + serial;
    const weights = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
    let sum = 0;

    for (let i = 0; i < 10; i++) {
      sum += parseInt(partial[i]) * weights[i];
    }

    const checkDigit = (10 - (sum % 10)) % 10;
    return partial + checkDigit;
  }
}